import React from 'react'
import { PropTypes } from 'prop-types';
import useInView from "react-cool-inview";
const { upperFirst } = require('lodash')

const SERVICES_TAG = 'Service';
const INDUSTRY_TAG = 'Industry';

const ProjectListItem = ({ article, displayTag }) => {
    const { observe, inView } = useInView();

    if (article) {
        const image = article.data.image && article.data.image.url ? article.data.image : article.data.listing_image
        const title = article.data.short_title && article.data.short_title.text ? article.data.short_title.text : article.data.title.text
        const tag = displayTag === SERVICES_TAG ? article.data.service : displayTag === INDUSTRY_TAG ? article.data.industry : null
        const Wrapper = article.url ? 'a' : 'div'

        return (
            <div className="c-project-listing__item" ref={observe}>
                <Wrapper href={article.url || undefined} className={inView ? "c-project-listing__item-wrapper is-inview" : "c-project-listing__item-wrapper"}>
                    <div className="c-project-listing__item-media-container">
                        <div className="c-project-listing__item-media-wrapper">
                            {image && image.url ? <img src={`${image.url}&w=500`} alt={image.alt ? image.alt : title} className="c-project-listing__item-media" loading="lazy"/> : <img src="https://picsum.photos/320/180" alt="" className="c-project-listing__item-media" loading="lazy"/> }
                        </div>
                        {tag ? <div className="c-project-listing__item-category">{upperFirst(tag)}</div> : null}
                    </div>
                    <h3 className="c-project-listing__item-title">{title}</h3>
                    {article.data.summary && article.data.summary.text ? <p className="c-project-listing__item-summary">{article.data.summary.text}</p> : null}
                 </Wrapper>
            </div>
        )
    }

    return null
}

ProjectListItem.propTypes = {
    displayTag: PropTypes.string
}

ProjectListItem.defaultProps = {
    displayTag: null
}

export default ProjectListItem
